import {
  useSelfRegisterGetValidateAccount,
  useSelfRegisterPostValidateAccount,
} from 'hooks/useRegistration';

export function useValidateToken() {

  const { mutate: getValidateToken, isLoading: isGettingValidateToken, isSuccess: hasGottenValidateToken, isError: failedGettingValidateToken, } = useSelfRegisterGetValidateAccount();
  const { mutate: postValidateToken, isLoading: isPostingValidateToken, isSuccess: hasPostedValidateToken, isError: failedPostingValidateToken, } = useSelfRegisterPostValidateAccount();

  return {
    getValidateToken,
    isGettingValidateToken,
    hasGottenValidateToken,
    failedGettingValidateToken,
    postValidateToken,
    isPostingValidateToken,
    hasPostedValidateToken,
    failedPostingValidateToken
  }
  
}
